import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'components/styles/search_sidebar.scss';

export default class SlidingSidebar extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    visible: PropTypes.bool
  };

  render() {

    const sidebarClass = classNames({
      'sliding-filter-sidebar': true,
      collapsed: !this.props.visible,
      'hidden-xs': true,
      'hidden-sm': true
    });

    return (
      <div className={sidebarClass}>
        {this.props.children}
      </div>
    );
  }
}
